import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { FlowchartService } from 'src/app/shared/services/API/self-triage/flowchart.service';

@Component({
  selector: 'app-self-triage-flowchart-delete-modal',
  templateUrl: './self-triage-flowchart-delete-modal.component.html',
  styleUrls: ['./self-triage-flowchart-delete-modal.component.css']
})
export class SelfTriageFlowchartDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  public dialog: MatDialog, 
  public matDialogRef: MatDialogRef<SelfTriageFlowchartDeleteModalComponent>,
  private flowchartService: FlowchartService,
  private alertService: AlertService) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteFlowchart: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.flowchartService.deleteFlowchart(this.data.idFlowchart).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Fluxograma excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteFlowchart: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteFlowchart: false}); 
  }
}
